import { Edit, Mail, MapPin, Phone, Save, User } from 'lucide-react';

const MiCuenta = () => {
  return (
    <div className="content-page">
      <div className="page-header">
        <h1>Mi Cuenta</h1>
        <button className="btn-primary">
          <Save size={16} />
          Guardar Cambios
        </button>
      </div>

      <div className="profile-container">
        <div className="profile-header">
          <div className="profile-avatar">
            <User size={48} />
          </div>
          <div className="profile-info">
            <h2>Administrador del Sistema</h2>
            <p>admin@bikerental.com</p>
            <span className="role-badge">Administrador</span>
          </div>
        </div>

        <div className="profile-sections">
          <div className="profile-section">
            <h3>Información Personal</h3>
            <div className="form-group">
              <label>
                <User size={16} />
                Nombre completo
              </label>
              <input type="text" defaultValue="Administrador del Sistema" />
            </div>
            <div className="form-group">
              <label>
                <Mail size={16} />
                Email
              </label>
              <input type="email" defaultValue="admin@bikerental.com" />
            </div>
            <div className="form-group">
              <label>
                <Phone size={16} />
                Teléfono
              </label>
              <input type="tel" defaultValue="+34 600 000 000" />
            </div>
            <div className="form-group">
              <label>
                <MapPin size={16} />
                Dirección
              </label>
              <input type="text" defaultValue="Calle Principal 123, Madrid" />
            </div>
          </div>

          <div className="profile-section">
            <h3>Cambiar Contraseña</h3>
            <div className="form-group">
              <label>Contraseña actual</label>
              <input type="password" placeholder="Ingresa tu contraseña actual" />
            </div>
            <div className="form-group">
              <label>Nueva contraseña</label>
              <input type="password" placeholder="Ingresa la nueva contraseña" />
            </div>
            <div className="form-group">
              <label>Confirmar nueva contraseña</label>
              <input type="password" placeholder="Confirma la nueva contraseña" />
            </div>
          </div>

          <div className="profile-section">
            <h3>Preferencias</h3>
            <div className="preference-item">
              <div className="preference-info">
                <h4>Notificaciones por email</h4>
                <p>Recibir actualizaciones importantes por correo</p>
              </div>
              <label className="toggle">
                <input type="checkbox" defaultChecked />
                <span className="slider"></span>
              </label>
            </div>
            <div className="preference-item">
              <div className="preference-info">
                <h4>Reportes semanales</h4>
                <p>Recibir resumen semanal de actividades</p>
              </div>
              <label className="toggle">
                <input type="checkbox" />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiCuenta; 